import React, {useEffect, useState} from 'react';
import Card from 'react-bootstrap/Card';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import { isBrowser } from "react-device-detect";
import WarningNotiifcation from 'components/WarningNotification';
import Form from 'react-bootstrap/Form';

const mt15 = {
    marginTop: 15
}

const formatPhoneNumber = (phone) => {
    if (phone && phone.length == 10) { 
        return `(${phone.substring(0,3)}) ${phone.substring(3,6)}-${phone.substring(6,10)}`
    } else {
        return phone
    }
}

const isBrowserMt = isBrowser ? mt15 : null;

const ExperienceCard = ({data, meses})  => {
    const [experience, setExperience] = useState([]);

    const formatter = new Intl.NumberFormat('en-US', {
        style: 'currency',
        currency: 'USD',
        minimumFractionDigits: 2
    })

    useEffect( () => {
        setExperience(data);
    }, [data])

    return (
        <>
        {
         experience && experience.length > 0 ? 
         experience.map((element, i) => {
           return (
            <Card key={element.id} style={i != 0 ? mt15 : null}>
                <Card.Body className={'p-30'}>
                <Row>
                    <Col xs={isBrowser ? 6 : 12}>
                        <Row>
                            <Col xs={isBrowser ? 3 : 12}>
                                <strong> Empresa </strong>
                            </Col>
                            <Col xs={isBrowser ? 9 : 12}>
                                {element.empresaNombre}
                            </Col>
                            <Col style={mt15} xs={isBrowser ? 3 : 12}>
                                <strong> Supervisor </strong>
                            </Col>
                            <Col style={isBrowserMt} xs={isBrowser ? 9 : 12}>
                                { element.supervisor }
                            </Col>
                            <Col style={mt15} xs={isBrowser ? 3 : 12}>
                                <strong> Puesto </strong>
                            </Col>
                            <Col style={isBrowserMt} xs={isBrowser ? 9 : 12}>
                             {element.ocupacion}
                            </Col>
                            <Col style={mt15} xs={isBrowser ? 3 : 12}>
                                <strong> Último salario mensual devengado </strong>
                            </Col>
                            <Col style={isBrowserMt} xs={isBrowser ? 9 : 12}>
                                { formatter.format(element.salario) } 
                            </Col>
                            <Col style={mt15} xs={isBrowser ? 3 : 12}>
                                <strong> Mes de inicio </strong>
                            </Col>
                            <Col style={isBrowserMt} xs={isBrowser ? 9 : 12}>
                                { element.mesInicioId ? meses.find(x => x.id === element.mesInicioId)?.nombre : 'No especificado' }
                            </Col>
                            <Col style={mt15} xs={isBrowser ? 3 : 12}>
                                <strong> Mes fin </strong>
                            </Col>
                            <Col style={isBrowserMt} xs={isBrowser ? 9 : 12}>
                                { element.mesFinId ? meses.find(x => x.id === element.mesFinId)?.nombre : 'No especificado' }
                            </Col>
                        </Row>
                    </Col>
                    <Col style={!isBrowser ? mt15 : null}  xs={isBrowser ? 6 : 12}>
                        <Row>
                            <Col xs={isBrowser ? 3 : 12}>
                                <strong> Actual </strong>
                            </Col>
                            <Col xs={isBrowser ? 9 : 12}>
                                { element.actual  === 1 ? 'Sí' : 'No' }
                            </Col>
                            <Col style={mt15} xs={isBrowser ? 3 : 12}>
                                <strong> Motivo de salida </strong>
                            </Col>
                            <Col style={isBrowserMt} xs={isBrowser ? 9 : 12}>
                                { element.motivoSalida ? element.motivoSalida : 'No especificado' }
                            </Col>
                            <Col style={mt15} xs={isBrowser ? 3 : 12}>
                                <strong> Teléfono </strong>
                            </Col>
                            <Col style={isBrowserMt} xs={isBrowser ? 9 : 12}>
                                {formatPhoneNumber(element.empresaTelefono) } 
                            </Col>
                            <Col style={mt15} xs={isBrowser ? 3 : 12}>
                                <strong> Año de inicio </strong>
                            </Col>
                            <Col style={isBrowserMt} xs={isBrowser ? 9 : 12}>
                                {element.anioInicio ? element.anioInicio : 'No especificado'}
                            </Col>
                            <Col style={mt15} xs={isBrowser ? 3 : 12}>
                                <strong> Año de fin </strong>
                            </Col>
                            <Col style={isBrowserMt} xs={isBrowser ? 9 : 12}>
                                {element.anioFin ? element.anioFin : 'No especificado'}
                            </Col>
                        </Row>
                    </Col>
                </Row>
            </Card.Body>
            </Card>
           )
        })
          :
          <Form.Group as={Col} md="12">
            <WarningNotiifcation message='No ha agregado formularios a la sección ' enphasis='Experiencia'/>
          </Form.Group>
       }
      </>  
    );
};

export default ExperienceCard;